module.exports = __webpack_public_path__ + "static/media/Datasecurity.174cb96c.jpg";